export const detect = (array, detectFunc) => {
    for (let i = 0; i < array.length; i++) {
        if (detectFunc(array[i])) {
            return array[i]
        }
    }
    return null;
};

export const detectObjectFromValue = (field, value) => {
    return (object) => {
        return (Array.isArray(value) && value.includes(object[field])) || object[field] === value
    }
}

export const roundedNumber = (number) => {
    if (number === null || number === undefined || Number.isNaN(number)) {
        return NaN;
    }
    return parseFloat(roundedString(number));
};

export const roundedString = (number, precision=2) => {
    let roundedString;

    if (typeof number === 'string') {
        roundedString = parseFloat(number).toFixed(precision);
    } else if (typeof number === 'number') {
        roundedString = number.toFixed(precision);
    } else {
        return NaN.toString();
    }

    return roundedString;
}

export const cacheObject = (key, object) => {
    localStorage.setItem(key, JSON.stringify(object));
  }

export const retrieveCachedObject = (key) => {
    const cachedObject = localStorage.getItem(key);
    if (cachedObject) {
        try {
            // Try to parse as JSON first
            const parsed = JSON.parse(cachedObject);
            return parsed;
        } catch (error) {
            // If parsing fails, handle as string
            // Check if it's a boolean string
            if (cachedObject === 'true') return true;
            if (cachedObject === 'false') return false;
            
            // Return the raw string value
            return cachedObject;
        }
    }
    return null;
}

export const persistState = (key, setFunc) => {
    return (value) => {
        if (typeof value === 'object' && value !== null) {
            cacheObject(key, value)
        } else if (typeof value === 'boolean') {
            // Store booleans as strings to avoid JSON parsing issues
            localStorage.setItem(key, value.toString());
        } else {
            localStorage.setItem(key, value);
        }
        
        setFunc(value);
    }
}

export const isNullOrUndefined = (value) => {
    return value === null || value === undefined;
}

export const formatStdDevLabel = (stdDevValue) => {
    if (!stdDevValue) return '';
    
    // Handle format like 'std_dev_1_5_upper' or 'std_dev_2_upper'
    const parts = stdDevValue.split('_');
    
    if (parts.length < 4) return '';
    
    // Extract the numeric value (could be '1', '1_5', '2', etc.)
    let value;
    if (parts[2] === '1' && parts[3] === '5') {
        // Handle 'std_dev_1_5_upper' format
        value = '1.5';
        const direction = parts[4] === 'upper' ? '+' : '-';
        return `${direction}${value} Std Dev`;
    } else {
        // Handle 'std_dev_1_upper' or 'std_dev_2_upper' format
        value = parts[2];
        const direction = parts[3] === 'upper' ? '+' : '-';
        return `${direction}${value} Std Dev`;
    }
};

// Numeric validation helpers
// Returns a non-negative finite number or null if invalid; optionally enforces integer semantics
export const coerceNonNegativeNumber = (value, options = {}) => {
    const { integer = false } = options;
    let num;
    if (typeof value === 'number') {
        num = value;
    } else if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed.length === 0) return null;
        num = Number(trimmed);
    } else {
        return null;
    }

    if (!Number.isFinite(num) || Number.isNaN(num)) return null;
    if (integer) {
        // Truncate toward zero to avoid rounding negatives to -0
        num = Math.trunc(num);
    }
    if (num < 0) return null;
    return num;
};

export const isNonNegativeNumber = (value) => coerceNonNegativeNumber(value) !== null;

// OPTIMIZED: Cache the currency formatter to avoid creating it on every call
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

// Currency formatting helper
export const formatCurrency = (value) => {
  if (value === null || value === undefined) return '$0.00';
  const num = parseFloat(value);
  if (!Number.isFinite(num)) return '$0.00';
  return currencyFormatter.format(num);
};